import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import { map as Rmap } from "ramda";
import { JSConn } from "@/utilities/js-conn";
import { format, formatDistance, subDays } from "date-fns";
import ProductivityChart from "@/components/ProductivityChart/ProductivityChart";
import TipTapDisplay from "@/components/TipTapDisplay/TipTapDisplay";

export default {
  name: "productivityDashboard",
  components: {
    LoadingAnimation,
    TipTapDisplay,
    ProductivityChart,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading the data...",
      dashboardOptions: {
        from_date: "",
      },
      sortBy: "scheduled_date",
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "scheduled_date", label: "Scheduled Date", sortable: true },
        { key: "client_name", label: "Client", sortable: true },
        { key: "field_name_with_cutting", label: "Field", sortable: true },
        { key: "commodity", label: "Commodity", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    workOrderNotes: function() {
      const apiNotes = this.$store.getters.workOrderNotes;
      const rightNow = new Date();
      return Rmap(nt => {
        const createdAt = new Date(nt.created_at);
        const humanizedDate = format(createdAt, "MMMM d, yyyy, h:mm a");
        const time_ago_in_words = formatDistance(rightNow, createdAt) + " ago";
        return {
          ...nt,
          humanized_created_at: humanizedDate,
          time_ago_in_words: time_ago_in_words,
        };
      }, apiNotes);
    },
    workOrderTasks: function() {
      return this.$store.getters.workOrderTasks;
    },
    workOrders: function() {
      return this.$store.getters.workOrdersForTable;
    },
  },
  methods: {
    submitForm(evt) {
      evt.preventDefault();
      // reload the data with the new options
      this.loadDashboardData();
    },
    queueWorkOrder(id) {
      const jsConn = new JSConn();
      const jsConnWorkOrders = new JSConn();

      const td = format(new Date(), "yyyy-MM-dd");
      jsConn.formParams = {
        id: id,
        start_date: td,
      };
      this.$store.dispatch("queueWorkOrder", jsConn).then(() => {
        // load all the work orders again
        // very likely a more efficient way to do this
        // but this is the least amount of code and the quickest at this time
        // 2019-03-27
        jsConnWorkOrders.formParams = {
          scheduled_after_date: this.dashboardOptions.from_date,
        };
        return this.$store.dispatch("needWorkOrders", jsConnWorkOrders);
      });
    },
    loadDashboardData() {
      this.dataLoaded = false;
      const jsConnWorkOrderNotes = new JSConn();
      const jsConnCompletedWorkOrderTasks = new JSConn();
      const jsConnLineItemSummaries = new JSConn();
      const jsConnScheduleWorkOrders = new JSConn();

      jsConnWorkOrderNotes.formParams = {
        from_date: this.dashboardOptions.from_date,
      };
      jsConnCompletedWorkOrderTasks.formParams = {
        from_date: this.dashboardOptions.from_date,
      };
      jsConnLineItemSummaries.formParams = {
        from_date: this.dashboardOptions.from_date,
      };

      jsConnScheduleWorkOrders.formParams = {
        scheduled_after_date: this.dashboardOptions.from_date,
      };

      const dataPromises = [
        this.$store.dispatch("needWorkOrderNotes", jsConnWorkOrderNotes),
        this.$store.dispatch(
          "needCompletedWorkOrderTasks",
          jsConnCompletedWorkOrderTasks,
        ),
        this.$store.dispatch("needLineItemSummaries", jsConnLineItemSummaries),
        this.$store.dispatch("needWorkOrders", jsConnScheduleWorkOrders),
      ];

      Promise.all(dataPromises).then(() => {
        this.dataLoaded = true;
      });
    },
  },
  created() {
    const fromDate = subDays(new Date(), 7);
    this.dashboardOptions.from_date = format(fromDate, "yyyy-MM-dd");

    this.loadDashboardData();
  },
};
